import React, { useRef } from "react";
import styles from "./CategoryUpdate.module.css";
import Toggle from "../../utils/Toggle/Toggle";

function CategoryFields({
  sort,
  setSort,
  name,
  setName,
  nonSelectedImage,
  nonSelectedImagePreview,
  onNonSelectedFileChange,
  selectedImage,
  selectedImagePreview,
  onSelectedFileChange,
  description,
  setDescription,
  subDescription,
  setSubDescription,
  status,
  setStatus,
  customImage,
  customImagePreview,
  onCustomFileChange,
}) {
  const nonSelectedRef = useRef(null);
  const selectedRef = useRef(null);
  const customRef = useRef(null);

  const nonSelectedDisplay = nonSelectedImagePreview || nonSelectedImage;
  const selectedDisplay = selectedImagePreview || selectedImage;
  const customDisplay = customImagePreview || customImage;

  return (
    <>
      <div className={styles.first}>
        <p>Enter the Sort Id</p>
        <input
          name="sortid"
          placeholder="Sort ID"
          type="number"
          onChange={(event) => setSort(event.target.value)}
          id={styles.gap}
          value={sort}
          required
        ></input>
      </div>
      <div className={styles.second}>
        <p>Enter the Category Name</p>
        <input
          name="fullname"
          placeholder="Category Name"
          type="text"
          onChange={(event) => setName(event.target.value)}
          id={styles.gap}
          value={name}
          required
        ></input>
      </div>
      <div className={styles.imageurl}>
        <p>Non-Selected Image</p>
        <div
          className={styles.imageUploadDiv}
          onClick={() => nonSelectedRef.current?.click()}
        >
          {nonSelectedDisplay ? (
            <img src={nonSelectedDisplay} alt="Non-Selected" className={styles.uploadedImage} />
          ) : (
            <span className={styles.uploadPlaceholder}>Click to upload non-selected image</span>
          )}
        </div>
        <input
          ref={nonSelectedRef}
          type="file"
          accept="image/*,image/svg+xml"
          onChange={onNonSelectedFileChange}
          style={{ display: "none" }}
        />
      </div>
      <div className={styles.selectedimageurl}>
        <p>Selected Image</p>
        <div
          className={styles.imageUploadDiv}
          onClick={() => selectedRef.current?.click()}
        >
          {selectedDisplay ? (
            <img src={selectedDisplay} alt="Selected" className={styles.uploadedImage} />
          ) : (
            <span className={styles.uploadPlaceholder}>Click to upload selected image</span>
          )}
        </div>
        <input
          ref={selectedRef}
          type="file"
          accept="image/*,image/svg+xml"
          onChange={onSelectedFileChange}
          style={{ display: "none" }}
        />
      </div>
      <div className={styles.fifth}>
        <p>Enter the Description</p>
        <textarea
          name="fullname"
          placeholder="Description"
          type="text"
          onChange={(event) => setDescription(event.target.value)}
          id={styles.gapdesc}
          value={description}
          required
        ></textarea>
      </div>
      <div className={styles.sixth}>
        <p>Enter the SubDescription</p>
        <textarea
          name="fullname"
          placeholder="Sub-Description"
          type="text"
          onChange={(event) => setSubDescription(event.target.value)}
          id={styles.gapdesc}
          value={subDescription}
        ></textarea>
      </div>
      <div className={styles.availability}>
        <p style={{ marginBottom: "16px" }}>
          Do you wanna allow Custom Products on this Category ?
        </p>
        <Toggle status={status} setStatus={setStatus} />
      </div>
      {status && (
        <div className={styles.sixth}>
          <p>Custom Image</p>
          <div
            className={styles.imageUploadDiv}
            onClick={() => customRef.current?.click()}
          >
            {customDisplay ? (
              <img src={customDisplay} alt="Custom" className={styles.uploadedImage} />
            ) : (
              <span className={styles.uploadPlaceholder}>Click to upload custom image</span>
            )}
          </div>
          <input
            ref={customRef}
            type="file"
            accept="image/*,image/svg+xml"
            onChange={onCustomFileChange}
            style={{ display: "none" }}
          />
        </div>
      )}
    </>
  );
}

export default CategoryFields;
